export enum OrderResumeStatusEnum {
	PENDING = 'PENDING',
	CREATING = 'CREATING',
	COMPLETED = 'COMPLETED',
	/**
	 * Falhou em todas as tentativas do worker. Estado FINAL: o backend para de
	 * reprocessar e o documento de resumo fica com status ERROR.
	 */
	ERROR = 'ERROR',
}
